"use client"

import { Search, ChevronDown } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"
import type { FilterBarProps } from "./FilterBar.types"

function FilterDropdown({ 
  value, 
  options, 
  onChange, 
  placeholder 
}: {
  value: string
  options: { value: string; label: string }[]
  onChange: (value: string) => void
  placeholder?: string
}) {

  
  const selectedLabel =
    options.find((option) => option.value === value)?.label ?? placeholder ?? ""

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className={cn(
        "inline-flex h-10 w-full items-center justify-between rounded-xl border border-[#9a9a9a] bg-white px-3 text-sm font-semibold text-[#2a2a2a] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]"
      )}>
        <span className="truncate">{selectedLabel}</span>
        <ChevronDown className="size-4 text-[#4b4b4b]" />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className="w-[var(--radix-dropdown-menu-trigger-width)] z-[9999]">
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
export default function FilterBar<T = any>({
  filters,
  values,
  onChange,
  searchValue,
  onSearchChange,
  searchPlaceholder = "search",
  className
}: FilterBarProps<T>) {
  return (
    <div className={cn("mb-1 grid grid-cols-1 gap-2 xl:grid-cols-6 overflow-visible relative z-50", className)}>
      
      {onSearchChange && (
        <div className="relative">
          <Search className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-[#1f1f1f]" />
          <Input
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={searchPlaceholder}
            className="h-10 rounded-xl border-[#9a9a9a] bg-white pr-9"
          />
        </div>
      )}

     
      {filters.map((filter) => (
        <FilterDropdown
          key={filter.key}
          value={values[filter.key] ?? ""}
          options={filter.options}
          onChange={(value) => onChange(filter.key, value)}
          placeholder={filter.placeholder}
        />
      ))}
    </div>
  )
}
